export default __webpack_public_path__ + "static/hero-image-8fb4fc2489c7a6154159a65a39b4cdf8.svg";